import axios from "axios";
import GLOBAL from "@/Global";


const http = axios.create({
    baseURL: GLOBAL.BASE_API,
    timeout: 20000,
    headers: {
        Accept: "application/json"
    }
});

export function parseAxiosError(err, fallback = "Ha ocurrido un error.") {
    const status = err?.response?.status;
    const data = err?.response?.data;

    return data?.message || data?.error || (typeof data === "string" ? data : status ? `HTTP ${status}` : fallback);
}

export default http;